<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id' :key="option.id">
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LPO_METHOD = 'get_lpo_method.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoMethod',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			id: null
		},
		watch: {
			id(val) {
				this.selected = val
				this.change()
			}
		},
		methods: {
			change () {
				EventBus.$emit(`lpo_method`, this.selected)
			}
		},
		created: function () {
			fetch(DB + LPO_METHOD, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.id ? this.id : data[0].id
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// lpoMethod.vue?61052c68